export default "__VITE_ASSET__DMx0_73u__"